module.exports = __webpack_public_path__ + "static/media/icon-reset.d08c55b7.svg";